module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADySURBVHgBpZM9DoJAFIQHoxbaQGOhDdQW4g2ksvUG4kmMN9EbUNugpZWY2EujBY1Y2GihPBeXBRYj4Us2ZH/eZPYxq7wiUIG6dDXYAlcPuHls3tIBYwq09dxRJeXgGQK7GXB2pLowbKA/TwklAncfcC32/QUVj/dAQ/1Ma3zjuMgXayYbInSGXMbU+KK/RI7uhI0sdMVgIwicVihNeMg4KC3gCQIVYDlQTfnuxSmupGxwB9oApaFgcYHOCOhJul30FyhQcZiSID2iFK6H/wXJcrlA0sSmyjZ0u7iYXFIKpVEWIReUja8bajL1ia6aQan6nN+MlFMzxbYP4gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/faild.png
// module id = Uy/e
// module chunks = 2